import { FeatureFlagKeys } from "@sg-protect/federation-runtime";
import { type ModuleRegisterFunction } from "@sg-protect/shell";

export const registerSharedReports: ModuleRegisterFunction = async runtime => {
    // Read once at boot against an anonymous LaunchDarkly context: the viewer never knows the share's workspace,
    // so here this flag is an on/off for everyone; only the backend can evaluate it per workspace.
    if (!runtime.getFeatureFlag(FeatureFlagKeys.ReportSharingReleased, false)) {
        // Still own /shared/*, or a share link would fall through to the Protect app and its ShareGate sign-in.
        const { registerUnreleasedRoutes } = await import("./routes.tsx");

        registerUnreleasedRoutes(runtime);

        return;
    }

    if (runtime.isMswEnabled) {
        const { handlers } = await import("./api/msw.ts");
        const { registerLoginRoutes } = await import("./features/login/register.tsx");

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        handlers.forEach(handler => Object.assign(handler, { mockModule: "shared-reports" }));

        runtime.registerRequestHandlers(handlers);
        registerLoginRoutes(runtime);
    }

    const { registerRoutes } = await import("./routes.tsx");

    registerRoutes(runtime);
};
